import { consumeAPI2 } from '../apiClient';

export function getPosting(id) {
  const pathUrl = `/postings/${id}`;

  return consumeAPI2(pathUrl).toPromise();
}
